import axiosInstance from '../axiosInterceptor/axiosInstance'

const base = (orgId, streamId) => `v1/orgs/${orgId}/streams/${streamId}/ad-queue`

// The event's videos queued for the stream's breaks (`items`), and everything the break plays in
// order (`upNext`): what is on air or on its way, then those videos with Mismatch ads slotted between
// them, never named. Each item has a `state`: Playing, Starting, Next or Queued.
export const getAdQueue = (orgId, streamId) =>
  axiosInstance.get(base(orgId, streamId)).then((r) => r.data)

// Queues one of the game's videos last, as a new entry even when it is already queued. Returns the queue.
export const addToAdQueue = (orgId, streamId, mediaId) =>
  axiosInstance.post(base(orgId, streamId), { mediaId }).then((r) => r.data)

export const removeFromAdQueue = (orgId, streamId, entryId) =>
  axiosInstance.delete(`${base(orgId, streamId)}/${entryId}`)

// Starts a break now: the queue plays until it is empty or the game resumes.
export const startAdBreak = (orgId, streamId) =>
  axiosInstance.post(`${base(orgId, streamId)}/start`)
